// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LANG_MAP, flagImg } from './shared-components';

export const HELP_TEXTS: Record<string, any> = {
  el: {
    helpButton: "Guide",
    title: "📋 ΟΔΗΓΙΕΣ ΧΡΗΣΗΣ — Ναυλοσύμφωνο & Λίστα Πληρώματος",
    welcome: "⚓ Καλωσήρθατε στην Tailwind Yachting!",
    intro: "Σας ευχαριστούμε που επιλέξατε εμάς για τις διακοπές σας στην Ελλάδα. Παρακάτω θα βρείτε αναλυτικές οδηγίες για να ολοκληρώσετε τη συμπλήρωση του Ναυλοσύμφωνου (Charter Party) και της Λίστας Πληρώματος (Crew List). Έχετε 3 επιλογές — διαλέξτε αυτή που σας βολεύει.",

    option1Title: "🔹 ΕΠΙΛΟΓΗ 1: Download → Συμπλήρωση → Upload",
    option1Steps: [
      "1. Συμπληρώστε τα δικά σας στοιχεία στη φόρμα + υπογράψτε ηλεκτρονικά.",
      "2. ⚠️ Πατήστε \"Αποθήκευση\" — απαραίτητο για να μπορέσετε να κατεβάσετε το Charter Party.",
      "3. Κατεβάστε το Charter Party DOCX για να δείτε τους όρους και ό,τι άλλο θέλετε.",
      "4. Κατεβάστε το Crew List DOCX.",
      "5. Συμπληρώστε το Crew List με έναν από τους εξής τρόπους: σε Word (συνιστάται), σε PDF, ή χειρόγραφα με στυλό (δεν το συνιστούμε).",
      "6. Ανεβάστε στο τέλος: το συμπληρωμένο Charter Party, το συμπληρωμένο Crew List, σαρωμένο ή φωτογραφία του διπλώματος Σκίπερ.",
      "7. Πατήστε \"Υποβολή\"."
    ],

    option2Title: "🔹 ΕΠΙΛΟΓΗ 2: Online με Links σε Crew Members (προτεινόμενη)",
    option2Steps: [
      "1. Συμπληρώστε τα δικά σας στοιχεία + υπογραφή ηλεκτρονικά.",
      "2. ⚠️ Πατήστε \"Αποθήκευση\" — απαραίτητο για να ανοίξετε το Charter Party.",
      "3. Πατήστε \"Charter Party DOCX\" για να ανοίξετε και να ελέγξετε το ναυλοσύμφωνο.",
      "4. Στοιχεία Σκίπερ: Αν είστε εσείς ο σκίπερ, πατήστε \"Είμαι ο ίδιος Σκίπερ\" — τα στοιχεία σας αντιγράφονται αυτόματα. Αν είναι άλλος, στείλτε invitation link στον σκίπερ — θα συμπληρώσει και θα υπογράψει μόνος του.",
      "5. Για κάθε μέλος του πληρώματος: πατήστε \"Πρόσκληση Μέλους\", συμπληρώστε το email του, το μέλος λαμβάνει σύνδεσμο και συμπληρώνει τα στοιχεία του, τα στοιχεία γεμίζουν αυτόματα στη λίστα.",
      "6. Ανεβάστε σαρωμένο ή φωτογραφία του διπλώματος Σκίπερ.",
      "7. Πατήστε \"Υποβολή\" όταν όλοι έχουν συμπληρώσει."
    ],

    option3Title: "🔹 ΕΠΙΛΟΓΗ 3: Όλα Online — Συμπλήρωση από τον Charterer",
    option3Steps: [
      "1. Συμπληρώστε τα δικά σας στοιχεία + υπογραφή ηλεκτρονικά.",
      "2. ⚠️ Πατήστε \"Αποθήκευση\" — απαραίτητο για να ανοίξετε το Charter Party.",
      "3. Πατήστε \"Charter Party DOCX\" για να το δείτε.",
      "4. Σκίπερ: Αν είστε εσείς ο σκίπερ, πατήστε \"Είμαι ο ίδιος Σκίπερ\" — τα στοιχεία σας αντιγράφονται αυτόματα. Αν είναι άλλος: στείλτε link στον σκίπερ → συμπληρώνει + υπογράφει μόνος του (έχουμε υπογραφή), ή συμπληρώστε εσείς τα στοιχεία του online (δεν θα έχουμε υπογραφή του).",
      "5. Crew Members: Συμπληρώνετε εσείς όλα τα στοιχεία στο online Crew List.",
      "6. Ανεβάστε σαρωμένο ή φωτογραφία του διπλώματος Σκίπερ.",
      "7. Πατήστε \"Υποβολή\"."
    ],

    contact: "📞 Χρειάζεστε βοήθεια; Επικοινωνήστε μαζί μας στο info@tailwindyachting.com",
    safe: "🌊 Καλό ταξίδι! ⛵",
    closeBtn: "← Κλείσιμο"
  },

  en: {
    helpButton: "Guide",
    title: "📋 USER INSTRUCTIONS — Charter Party & Crew List",
    welcome: "⚓ Welcome to Tailwind Yachting!",
    intro: "Thank you for choosing us for your holidays in Greece. Below you will find detailed instructions for completing the Charter Party and Crew List. You have 3 options — choose the one that suits you.",

    option1Title: "🔹 OPTION 1: Download → Fill in → Upload",
    option1Steps: [
      "1. Fill in your details in the form + sign electronically.",
      "2. ⚠️ Click \"Save\" — required to download the Charter Party.",
      "3. Download the Charter Party DOCX to read the terms and anything else you want.",
      "4. Download the Crew List DOCX.",
      "5. Complete the Crew List in one of the following ways: in Word (recommended), in PDF, or by hand with a pen (not recommended).",
      "6. Upload at the end: the completed Charter Party, the completed Crew List, scanned or photo of the Skipper licence.",
      "7. Click \"Submit\"."
    ],

    option2Title: "🔹 OPTION 2: Online with Links to Crew Members (recommended)",
    option2Steps: [
      "1. Fill in your details + sign electronically.",
      "2. ⚠️ Click \"Save\" — required to open the Charter Party.",
      "3. Click \"Charter Party DOCX\" to open and review the agreement.",
      "4. Skipper details: If you are the skipper, click \"I am the Skipper\" — your details are copied automatically. If someone else, send an invitation link to the skipper — they will fill in and sign themselves.",
      "5. For each crew member: click \"Invite Member\", enter their email, the member receives a link and fills in their details, the data is automatically added to the list.",
      "6. Upload scanned or photo of the Skipper licence.",
      "7. Click \"Submit\" once everyone has filled in their details."
    ],

    option3Title: "🔹 OPTION 3: All Online — Filled in by Charterer",
    option3Steps: [
      "1. Fill in your details + sign electronically.",
      "2. ⚠️ Click \"Save\" — required to open the Charter Party.",
      "3. Click \"Charter Party DOCX\" to view it.",
      "4. Skipper: If you are the skipper, click \"I am the Skipper\" — your details are copied automatically. If someone else: send a link to the skipper → they fill in + sign themselves (we have signature), or you fill in their details online (we won't have their signature).",
      "5. Crew Members: You fill in all details in the online Crew List.",
      "6. Upload scanned or photo of the Skipper licence.",
      "7. Click \"Submit\"."
    ],

    contact: "📞 Need help? Contact us at info@tailwindyachting.com",
    safe: "🌊 Have a great trip! ⛵",
    closeBtn: "← Close"
  },

  it: {
    helpButton: "Guide",
    title: "📋 ISTRUZIONI — Contratto di Noleggio & Lista Equipaggio",
    welcome: "⚓ Benvenuti a Tailwind Yachting!",
    intro: "Grazie per aver scelto noi per le vostre vacanze in Grecia. Di seguito troverete istruzioni dettagliate per completare il Contratto di Noleggio (Charter Party) e la Lista Equipaggio (Crew List). Avete 3 opzioni — scegliete quella che vi conviene.",

    option1Title: "🔹 OPZIONE 1: Scarica → Compila → Carica",
    option1Steps: [
      "1. Inserite i vostri dati nel modulo + firmate elettronicamente.",
      "2. ⚠️ Cliccate \"Salva\" — necessario per scaricare il Charter Party.",
      "3. Scaricate il Charter Party DOCX per leggere i termini.",
      "4. Scaricate il Crew List DOCX.",
      "5. Compilate il Crew List in uno dei seguenti modi: in Word (consigliato), in PDF, o a mano con penna (non consigliato).",
      "6. Caricate alla fine: il Charter Party compilato, il Crew List compilato, scansione o foto della patente nautica dello Skipper.",
      "7. Cliccate \"Invia\"."
    ],

    option2Title: "🔹 OPZIONE 2: Online con Link ai Membri (consigliata)",
    option2Steps: [
      "1. Inserite i vostri dati + firma elettronica.",
      "2. ⚠️ Cliccate \"Salva\" — necessario per aprire il Charter Party.",
      "3. Cliccate \"Charter Party DOCX\" per aprire e controllare il contratto.",
      "4. Dati Skipper: Se siete voi lo skipper, cliccate \"Sono io lo Skipper\" — i vostri dati vengono copiati automaticamente. Se è un altro, inviate un link di invito allo skipper — compilerà e firmerà da solo.",
      "5. Per ogni membro dell'equipaggio: cliccate \"Invita Membro\", inserite la sua email, il membro riceve un link e compila i suoi dati, i dati vengono aggiunti automaticamente alla lista.",
      "6. Caricate scansione o foto della patente nautica dello Skipper.",
      "7. Cliccate \"Invia\" quando tutti hanno compilato."
    ],

    option3Title: "🔹 OPZIONE 3: Tutto Online — Compilazione dal Charterer",
    option3Steps: [
      "1. Inserite i vostri dati + firma elettronica.",
      "2. ⚠️ Cliccate \"Salva\" — necessario per aprire il Charter Party.",
      "3. Cliccate \"Charter Party DOCX\" per vederlo.",
      "4. Skipper: Se siete voi lo skipper, cliccate \"Sono io lo Skipper\" — i vostri dati vengono copiati automaticamente. Se è un altro: inviate un link allo skipper → compila + firma da solo (abbiamo firma), oppure compilate voi i suoi dati online (non avremo la sua firma).",
      "5. Membri Equipaggio: Compilate voi tutti i dati nel Crew List online.",
      "6. Caricate scansione o foto della patente nautica dello Skipper.",
      "7. Cliccate \"Invia\"."
    ],

    contact: "📞 Bisogno di aiuto? Contattateci a info@tailwindyachting.com",
    safe: "🌊 Buon viaggio! ⛵",
    closeBtn: "← Chiudi"
  },

  de: {
    helpButton: "Guide",
    title: "📋 ANLEITUNG — Chartervertrag & Crewliste",
    welcome: "⚓ Willkommen bei Tailwind Yachting!",
    intro: "Vielen Dank, dass Sie uns für Ihren Urlaub in Griechenland gewählt haben. Nachfolgend finden Sie ausführliche Anweisungen zum Ausfüllen des Chartervertrags (Charter Party) und der Crewliste (Crew List). Sie haben 3 Möglichkeiten — wählen Sie die für Sie passende.",

    option1Title: "🔹 OPTION 1: Herunterladen → Ausfüllen → Hochladen",
    option1Steps: [
      "1. Füllen Sie Ihre Daten im Formular aus + unterschreiben Sie elektronisch.",
      "2. ⚠️ Klicken Sie \"Speichern\" — erforderlich, um den Chartervertrag herunterzuladen.",
      "3. Laden Sie den Charter Party DOCX herunter, um die Bedingungen zu lesen.",
      "4. Laden Sie den Crew List DOCX herunter.",
      "5. Füllen Sie die Crew List auf eine der folgenden Arten aus: in Word (empfohlen), in PDF, oder handschriftlich mit Stift (nicht empfohlen).",
      "6. Laden Sie am Ende hoch: den ausgefüllten Charter Party, die ausgefüllte Crew List, gescanntes oder Foto des Skipper-Patents.",
      "7. Klicken Sie \"Absenden\"."
    ],

    option2Title: "🔹 OPTION 2: Online mit Links an Crewmitglieder (empfohlen)",
    option2Steps: [
      "1. Füllen Sie Ihre Daten aus + elektronische Unterschrift.",
      "2. ⚠️ Klicken Sie \"Speichern\" — erforderlich, um den Chartervertrag zu öffnen.",
      "3. Klicken Sie \"Charter Party DOCX\", um den Vertrag zu öffnen und zu überprüfen.",
      "4. Skipper-Daten: Wenn Sie der Skipper sind, klicken Sie \"Ich bin der Skipper\" — Ihre Daten werden automatisch kopiert. Wenn jemand anderes, senden Sie einen Einladungslink an den Skipper — er füllt aus und unterschreibt selbst.",
      "5. Für jedes Crewmitglied: klicken Sie \"Mitglied einladen\", geben Sie seine E-Mail ein, das Mitglied erhält einen Link und füllt seine Daten aus, die Daten werden automatisch zur Liste hinzugefügt.",
      "6. Laden Sie gescanntes oder Foto des Skipper-Patents hoch.",
      "7. Klicken Sie \"Absenden\", wenn alle ausgefüllt haben."
    ],

    option3Title: "🔹 OPTION 3: Alles Online — Ausgefüllt vom Charterer",
    option3Steps: [
      "1. Füllen Sie Ihre Daten aus + elektronische Unterschrift.",
      "2. ⚠️ Klicken Sie \"Speichern\" — erforderlich, um den Chartervertrag zu öffnen.",
      "3. Klicken Sie \"Charter Party DOCX\", um ihn anzusehen.",
      "4. Skipper: Wenn Sie der Skipper sind, klicken Sie \"Ich bin der Skipper\" — Ihre Daten werden automatisch kopiert. Wenn jemand anderes: senden Sie einen Link an den Skipper → er füllt aus + unterschreibt selbst (wir haben Unterschrift), oder Sie füllen seine Daten online aus (wir haben seine Unterschrift nicht).",
      "5. Crewmitglieder: Sie füllen alle Daten in der Online-Crewliste aus.",
      "6. Laden Sie gescanntes oder Foto des Skipper-Patents hoch.",
      "7. Klicken Sie \"Absenden\"."
    ],

    contact: "📞 Hilfe benötigt? Kontaktieren Sie uns unter info@tailwindyachting.com",
    safe: "🌊 Gute Reise! ⛵",
    closeBtn: "← Schließen"
  },

  ru: {
    helpButton: "Guide",
    title: "📋 ИНСТРУКЦИИ — Договор фрахтования & Список экипажа",
    welcome: "⚓ Добро пожаловать в Tailwind Yachting!",
    intro: "Благодарим вас за выбор нашей компании для отдыха в Греции. Ниже вы найдете подробные инструкции по заполнению Договора фрахтования (Charter Party) и Списка экипажа (Crew List). У вас есть 3 варианта — выберите тот, который вам удобен.",

    option1Title: "🔹 ВАРИАНТ 1: Скачать → Заполнить → Загрузить",
    option1Steps: [
      "1. Заполните свои данные в форме + подпишите электронно.",
      "2. ⚠️ Нажмите \"Сохранить\" — необходимо для скачивания Charter Party.",
      "3. Скачайте Charter Party DOCX, чтобы прочитать условия.",
      "4. Скачайте Crew List DOCX.",
      "5. Заполните Crew List одним из следующих способов: в Word (рекомендуется), в PDF, или от руки ручкой (не рекомендуется).",
      "6. Загрузите в конце: заполненный Charter Party, заполненный Crew List, скан или фото удостоверения шкипера.",
      "7. Нажмите \"Отправить\"."
    ],

    option2Title: "🔹 ВАРИАНТ 2: Онлайн со ссылками членам экипажа (рекомендуется)",
    option2Steps: [
      "1. Заполните свои данные + электронная подпись.",
      "2. ⚠️ Нажмите \"Сохранить\" — необходимо для открытия Charter Party.",
      "3. Нажмите \"Charter Party DOCX\", чтобы открыть и проверить договор.",
      "4. Данные шкипера: Если вы шкипер, нажмите \"Я шкипер\" — ваши данные копируются автоматически. Если другой, отправьте ссылку-приглашение шкиперу — он заполнит и подпишет сам.",
      "5. Для каждого члена экипажа: нажмите \"Пригласить члена\", введите его email, член получает ссылку и заполняет свои данные, данные автоматически добавляются в список.",
      "6. Загрузите скан или фото удостоверения шкипера.",
      "7. Нажмите \"Отправить\", когда все заполнят."
    ],

    option3Title: "🔹 ВАРИАНТ 3: Всё онлайн — Заполнение фрахтователем",
    option3Steps: [
      "1. Заполните свои данные + электронная подпись.",
      "2. ⚠️ Нажмите \"Сохранить\" — необходимо для открытия Charter Party.",
      "3. Нажмите \"Charter Party DOCX\", чтобы посмотреть.",
      "4. Шкипер: Если вы шкипер, нажмите \"Я шкипер\" — ваши данные копируются автоматически. Если другой: отправьте ссылку шкиперу → заполнит + подпишет сам (имеем подпись), или заполните вы его данные онлайн (не будет его подписи).",
      "5. Члены экипажа: Вы заполняете все данные в онлайн Crew List.",
      "6. Загрузите скан или фото удостоверения шкипера.",
      "7. Нажмите \"Отправить\"."
    ],

    contact: "📞 Нужна помощь? Свяжитесь с нами: info@tailwindyachting.com",
    safe: "🌊 Счастливого пути! ⛵",
    closeBtn: "← Закрыть"
  },

  fr: {
    helpButton: "Guide",
    title: "📋 INSTRUCTIONS — Contrat d'Affrètement & Liste d'Équipage",
    welcome: "⚓ Bienvenue chez Tailwind Yachting !",
    intro: "Merci de nous avoir choisis pour vos vacances en Grèce. Vous trouverez ci-dessous des instructions détaillées pour compléter le Contrat d'Affrètement (Charter Party) et la Liste d'Équipage (Crew List). Vous avez 3 options — choisissez celle qui vous convient.",

    option1Title: "🔹 OPTION 1 : Télécharger → Remplir → Envoyer",
    option1Steps: [
      "1. Remplissez vos coordonnées dans le formulaire + signez électroniquement.",
      "2. ⚠️ Cliquez sur \"Enregistrer\" — nécessaire pour télécharger le Charter Party.",
      "3. Téléchargez le Charter Party DOCX pour lire les termes.",
      "4. Téléchargez le Crew List DOCX.",
      "5. Remplissez le Crew List de l'une des manières suivantes : en Word (recommandé), en PDF, ou à la main avec un stylo (non recommandé).",
      "6. Envoyez à la fin : le Charter Party complété, le Crew List complété, scan ou photo du permis du Skipper.",
      "7. Cliquez sur \"Soumettre\"."
    ],

    option2Title: "🔹 OPTION 2 : En ligne avec liens aux membres (recommandée)",
    option2Steps: [
      "1. Remplissez vos coordonnées + signature électronique.",
      "2. ⚠️ Cliquez sur \"Enregistrer\" — nécessaire pour ouvrir le Charter Party.",
      "3. Cliquez sur \"Charter Party DOCX\" pour ouvrir et vérifier le contrat.",
      "4. Données du Skipper : Si vous êtes le skipper, cliquez sur \"Je suis le Skipper\" — vos données sont copiées automatiquement. Si quelqu'un d'autre, envoyez un lien d'invitation au skipper — il remplira et signera lui-même.",
      "5. Pour chaque membre d'équipage : cliquez sur \"Inviter Membre\", entrez son email, le membre reçoit un lien et remplit ses données, les données sont ajoutées automatiquement à la liste.",
      "6. Envoyez scan ou photo du permis du Skipper.",
      "7. Cliquez sur \"Soumettre\" quand tous ont rempli."
    ],

    option3Title: "🔹 OPTION 3 : Tout en ligne — Rempli par le Charterer",
    option3Steps: [
      "1. Remplissez vos coordonnées + signature électronique.",
      "2. ⚠️ Cliquez sur \"Enregistrer\" — nécessaire pour ouvrir le Charter Party.",
      "3. Cliquez sur \"Charter Party DOCX\" pour le voir.",
      "4. Skipper : Si vous êtes le skipper, cliquez sur \"Je suis le Skipper\" — vos données sont copiées automatiquement. Si quelqu'un d'autre : envoyez un lien au skipper → remplit + signe lui-même (nous avons signature), ou vous remplissez ses données en ligne (nous n'aurons pas sa signature).",
      "5. Membres d'Équipage : Vous remplissez toutes les données dans le Crew List en ligne.",
      "6. Envoyez scan ou photo du permis du Skipper.",
      "7. Cliquez sur \"Soumettre\"."
    ],

    contact: "📞 Besoin d'aide ? Contactez-nous à info@tailwindyachting.com",
    safe: "🌊 Bon voyage ! ⛵",
    closeBtn: "← Fermer"
  },

  ro: {
    helpButton: "Guide",
    title: "📋 INSTRUCȚIUNI — Contract de Navlosire & Lista Echipajului",
    welcome: "⚓ Bine ați venit la Tailwind Yachting!",
    intro: "Vă mulțumim că ne-ați ales pentru vacanța dumneavoastră în Grecia. Mai jos veți găsi instrucțiuni detaliate pentru completarea Contractului de Navlosire (Charter Party) și a Listei Echipajului (Crew List). Aveți 3 opțiuni — alegeți pe cea care vă convine.",

    option1Title: "🔹 OPȚIUNEA 1: Descărcare → Completare → Încărcare",
    option1Steps: [
      "1. Completați datele dvs. în formular + semnați electronic.",
      "2. ⚠️ Apăsați \"Salvează\" — necesar pentru a descărca Charter Party.",
      "3. Descărcați Charter Party DOCX pentru a citi termenii.",
      "4. Descărcați Crew List DOCX.",
      "5. Completați Crew List în una din următoarele moduri: în Word (recomandat), în PDF, sau de mână cu pix (nu recomandăm).",
      "6. Încărcați la final: Charter Party completat, Crew List completat, scanare sau fotografie a brevetului de Skipper.",
      "7. Apăsați \"Trimite\"."
    ],

    option2Title: "🔹 OPȚIUNEA 2: Online cu Link-uri către membri (recomandată)",
    option2Steps: [
      "1. Completați datele dvs. + semnătură electronică.",
      "2. ⚠️ Apăsați \"Salvează\" — necesar pentru a deschide Charter Party.",
      "3. Apăsați \"Charter Party DOCX\" pentru a deschide și verifica contractul.",
      "4. Date Skipper: Dacă sunteți dvs. skipperul, apăsați \"Sunt eu Skipper-ul\" — datele dvs. se copiază automat. Dacă este altcineva, trimiteți link de invitație skipperului — va completa și semna singur.",
      "5. Pentru fiecare membru al echipajului: apăsați \"Invită Membru\", introduceți email-ul lui, membrul primește un link și își completează datele, datele se adaugă automat în listă.",
      "6. Încărcați scanare sau fotografie a brevetului de Skipper.",
      "7. Apăsați \"Trimite\" când toți au completat."
    ],

    option3Title: "🔹 OPȚIUNEA 3: Totul Online — Completat de Charterer",
    option3Steps: [
      "1. Completați datele dvs. + semnătură electronică.",
      "2. ⚠️ Apăsați \"Salvează\" — necesar pentru a deschide Charter Party.",
      "3. Apăsați \"Charter Party DOCX\" pentru a-l vedea.",
      "4. Skipper: Dacă sunteți dvs. skipperul, apăsați \"Sunt eu Skipper-ul\" — datele dvs. se copiază automat. Dacă este altcineva: trimiteți link skipperului → completează + semnează singur (avem semnătura), sau completați dvs. datele lui online (nu vom avea semnătura lui).",
      "5. Membrii Echipajului: Dvs. completați toate datele în Crew List online.",
      "6. Încărcați scanare sau fotografie a brevetului de Skipper.",
      "7. Apăsați \"Trimite\"."
    ],

    contact: "📞 Aveți nevoie de ajutor? Contactați-ne la info@tailwindyachting.com",
    safe: "🌊 Călătorie plăcută! ⛵",
    closeBtn: "← Închide"
  },

  pl: {
    helpButton: "Guide",
    title: "📋 INSTRUKCJE — Umowa Czarteru & Lista Załogi",
    welcome: "⚓ Witamy w Tailwind Yachting!",
    intro: "Dziękujemy za wybór naszej firmy na wakacje w Grecji. Poniżej znajdą Państwo szczegółowe instrukcje dotyczące wypełnienia Umowy Czarteru (Charter Party) i Listy Załogi (Crew List). Mają Państwo 3 opcje — wybierzcie tę, która Wam odpowiada.",

    option1Title: "🔹 OPCJA 1: Pobierz → Wypełnij → Wyślij",
    option1Steps: [
      "1. Wypełnij swoje dane w formularzu + podpisz elektronicznie.",
      "2. ⚠️ Kliknij \"Zapisz\" — wymagane do pobrania Charter Party.",
      "3. Pobierz Charter Party DOCX, aby przeczytać warunki.",
      "4. Pobierz Crew List DOCX.",
      "5. Wypełnij Crew List w jeden z następujących sposobów: w Word (zalecane), w PDF, lub odręcznie długopisem (nie zalecamy).",
      "6. Prześlij na koniec: wypełniony Charter Party, wypełniony Crew List, skan lub zdjęcie patentu Skippera.",
      "7. Kliknij \"Wyślij\"."
    ],

    option2Title: "🔹 OPCJA 2: Online z linkami do członków załogi (zalecana)",
    option2Steps: [
      "1. Wypełnij swoje dane + podpis elektroniczny.",
      "2. ⚠️ Kliknij \"Zapisz\" — wymagane do otwarcia Charter Party.",
      "3. Kliknij \"Charter Party DOCX\", aby otworzyć i sprawdzić umowę.",
      "4. Dane Skippera: Jeśli jesteś skipperem, kliknij \"Jestem Skipperem\" — Twoje dane są kopiowane automatycznie. Jeśli ktoś inny, wyślij link zaproszenia do skippera — wypełni i podpisze sam.",
      "5. Dla każdego członka załogi: kliknij \"Zaproś Członka\", wprowadź jego email, członek otrzymuje link i wypełnia swoje dane, dane są automatycznie dodawane do listy.",
      "6. Prześlij skan lub zdjęcie patentu Skippera.",
      "7. Kliknij \"Wyślij\", gdy wszyscy wypełnili."
    ],

    option3Title: "🔹 OPCJA 3: Wszystko online — Wypełnione przez Charterera",
    option3Steps: [
      "1. Wypełnij swoje dane + podpis elektroniczny.",
      "2. ⚠️ Kliknij \"Zapisz\" — wymagane do otwarcia Charter Party.",
      "3. Kliknij \"Charter Party DOCX\", aby go zobaczyć.",
      "4. Skipper: Jeśli jesteś skipperem, kliknij \"Jestem Skipperem\" — Twoje dane są kopiowane automatycznie. Jeśli ktoś inny: wyślij link skipperowi → wypełnia + podpisuje sam (mamy podpis), lub wypełnij sam jego dane online (nie będziemy mieli jego podpisu).",
      "5. Członkowie Załogi: Wypełniasz sam wszystkie dane w online Crew List.",
      "6. Prześlij skan lub zdjęcie patentu Skippera.",
      "7. Kliknij \"Wyślij\"."
    ],

    contact: "📞 Potrzebujesz pomocy? Skontaktuj się z nami: info@tailwindyachting.com",
    safe: "🌊 Udanej podróży! ⛵",
    closeBtn: "← Zamknij"
  },

  he: {
    helpButton: "Guide",
    title: "📋 הוראות שימוש — חוזה שכירת יאכטה ורשימת צוות",
    welcome: "⚓ ברוכים הבאים ל-Tailwind Yachting!",
    intro: "תודה שבחרתם בנו לחופשתכם ביוון. להלן הוראות מפורטות למילוי חוזה שכירת היאכטה (Charter Party) ורשימת הצוות (Crew List). יש לכם 3 אפשרויות — בחרו את זו שמתאימה לכם.",

    option1Title: "🔹 אפשרות 1: הורדה → מילוי → העלאה",
    option1Steps: [
      "1. מלאו את פרטיכם בטופס + חתמו אלקטרונית.",
      "2. ⚠️ לחצו \"שמור\" — נדרש להורדת Charter Party.",
      "3. הורידו את Charter Party DOCX כדי לקרוא את התנאים.",
      "4. הורידו את Crew List DOCX.",
      "5. מלאו את Crew List באחת הדרכים הבאות: ב-Word (מומלץ), ב-PDF, או בכתב יד עם עט (לא מומלץ).",
      "6. העלו בסוף: Charter Party המלא, Crew List המלא, סריקה או תצלום של רישיון הסקיפר.",
      "7. לחצו \"שלח\"."
    ],

    option2Title: "🔹 אפשרות 2: אונליין עם קישורים לאנשי צוות (מומלץ)",
    option2Steps: [
      "1. מלאו את פרטיכם + חתימה אלקטרונית.",
      "2. ⚠️ לחצו \"שמור\" — נדרש לפתיחת Charter Party.",
      "3. לחצו \"Charter Party DOCX\" כדי לפתוח ולבדוק את החוזה.",
      "4. פרטי סקיפר: אם אתם הסקיפר, לחצו \"אני הסקיפר\" — פרטיכם מועתקים אוטומטית. אם מישהו אחר, שלחו קישור הזמנה לסקיפר — הוא ימלא ויחתום בעצמו.",
      "5. עבור כל איש צוות: לחצו \"הזמן חבר\", הזינו את כתובת המייל שלו, האיש מקבל קישור וממלא את פרטיו, הנתונים מתווספים אוטומטית לרשימה.",
      "6. העלו סריקה או תצלום של רישיון הסקיפר.",
      "7. לחצו \"שלח\" כאשר כולם מילאו."
    ],

    option3Title: "🔹 אפשרות 3: הכל אונליין — מילוי על ידי הצ'רטרר",
    option3Steps: [
      "1. מלאו את פרטיכם + חתימה אלקטרונית.",
      "2. ⚠️ לחצו \"שמור\" — נדרש לפתיחת Charter Party.",
      "3. לחצו \"Charter Party DOCX\" כדי לצפות בו.",
      "4. סקיפר: אם אתם הסקיפר, לחצו \"אני הסקיפר\" — פרטיכם מועתקים אוטומטית. אם מישהו אחר: שלחו קישור לסקיפר → ממלא + חותם בעצמו (יש לנו חתימה), או מלאו בעצמכם את פרטיו אונליין (לא תהיה לנו חתימתו).",
      "5. אנשי צוות: אתם ממלאים את כל הפרטים ב-Crew List אונליין.",
      "6. העלו סריקה או תצלום של רישיון הסקיפר.",
      "7. לחצו \"שלח\"."
    ],

    contact: "📞 צריכים עזרה? צרו קשר: info@tailwindyachting.com",
    safe: "🌊 נסיעה טובה! ⛵",
    closeBtn: "← סגור"
  },

  es: {
    helpButton: "Guide",
    title: "📋 INSTRUCCIONES — Contrato de Fletamento & Lista de Tripulación",
    welcome: "⚓ ¡Bienvenidos a Tailwind Yachting!",
    intro: "Gracias por elegirnos para sus vacaciones en Grecia. A continuación encontrará instrucciones detalladas para completar el Contrato de Fletamento (Charter Party) y la Lista de Tripulación (Crew List). Tiene 3 opciones — elija la que más le convenga.",

    option1Title: "🔹 OPCIÓN 1: Descargar → Rellenar → Subir",
    option1Steps: [
      "1. Complete sus datos en el formulario + firme electrónicamente.",
      "2. ⚠️ Pulse \"Guardar\" — necesario para descargar el Charter Party.",
      "3. Descargue el Charter Party DOCX para leer los términos.",
      "4. Descargue el Crew List DOCX.",
      "5. Complete el Crew List de una de las siguientes formas: en Word (recomendado), en PDF, o a mano con bolígrafo (no recomendado).",
      "6. Suba al final: el Charter Party completado, el Crew List completado, escaneo o foto del título del Patrón.",
      "7. Pulse \"Enviar\"."
    ],

    option2Title: "🔹 OPCIÓN 2: Online con Enlaces a miembros (recomendada)",
    option2Steps: [
      "1. Complete sus datos + firma electrónica.",
      "2. ⚠️ Pulse \"Guardar\" — necesario para abrir el Charter Party.",
      "3. Pulse \"Charter Party DOCX\" para abrir y revisar el contrato.",
      "4. Datos del Patrón: Si usted es el patrón, pulse \"Soy el Patrón\" — sus datos se copian automáticamente. Si es otra persona, envíe un enlace de invitación al patrón — completará y firmará él mismo.",
      "5. Para cada miembro de la tripulación: pulse \"Invitar Miembro\", introduzca su email, el miembro recibe un enlace y completa sus datos, los datos se añaden automáticamente a la lista.",
      "6. Suba escaneo o foto del título del Patrón.",
      "7. Pulse \"Enviar\" cuando todos hayan completado."
    ],

    option3Title: "🔹 OPCIÓN 3: Todo Online — Completado por el Charterer",
    option3Steps: [
      "1. Complete sus datos + firma electrónica.",
      "2. ⚠️ Pulse \"Guardar\" — necesario para abrir el Charter Party.",
      "3. Pulse \"Charter Party DOCX\" para verlo.",
      "4. Patrón: Si usted es el patrón, pulse \"Soy el Patrón\" — sus datos se copian automáticamente. Si es otra persona: envíe un enlace al patrón → completa + firma él mismo (tenemos firma), o complete usted mismo sus datos online (no tendremos su firma).",
      "5. Miembros de Tripulación: Usted completa todos los datos en el Crew List online.",
      "6. Suba escaneo o foto del título del Patrón.",
      "7. Pulse \"Enviar\"."
    ],

    contact: "📞 ¿Necesita ayuda? Contáctenos en info@tailwindyachting.com",
    safe: "🌊 ¡Buen viaje! ⛵",
    closeBtn: "← Cerrar"
  }
};

const CharterGuidePage: React.FC = () => {
  const navigate = useNavigate();
  const [lang, setLang] = useState('en');
  const [showLangPopup, setShowLangPopup] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlLang = urlParams.get('lang');
    const sessionLang = sessionStorage.getItem('yacht_lang');
    const finalLang = urlLang || sessionLang || 'en';
    setLang(finalLang);
    if (urlLang && urlLang !== sessionLang) {
      sessionStorage.setItem('yacht_lang', urlLang);
    }
  }, []);

  const changeLanguage = (newLang: string) => {
    setLang(newLang);
    sessionStorage.setItem('yacht_lang', newLang);
    setShowLangPopup(false);
  };

  const h = HELP_TEXTS[lang] || HELP_TEXTS.en;
  const isRtl = lang === 'he';

  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    card: {
      maxWidth: '800px',
      margin: '0 auto',
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '40px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
    },
    headerRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '12px',
      marginBottom: '24px',
      flexWrap: 'wrap' as const
    },
    title: {
      fontSize: '1.6rem',
      fontWeight: '700',
      color: '#1e40af',
      margin: 0,
      flex: 1,
      minWidth: 0
    },
    langButton: {
      padding: '8px 16px',
      background: '#dbeafe',
      border: '1px solid #93c5fd',
      borderRadius: '8px',
      cursor: 'pointer',
      fontWeight: 'bold' as const,
      color: '#1e40af',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    welcome: {
      fontWeight: 'bold' as const,
      fontSize: '1.1rem',
      margin: '12px 0',
      color: '#0c4a6e'
    },
    intro: {
      margin: '12px 0 20px 0',
      lineHeight: '1.6',
      color: '#374151'
    },
    optionBlue: {
      background: '#f0f9ff',
      border: '1px solid #93c5fd',
      borderRadius: '8px',
      padding: '14px',
      margin: '14px 0'
    },
    optionGreen: {
      background: '#ecfdf5',
      border: '2px solid #10b981',
      borderRadius: '8px',
      padding: '14px',
      margin: '14px 0'
    },
    optionYellow: {
      background: '#fef3c7',
      border: '1px solid #fbbf24',
      borderRadius: '8px',
      padding: '14px',
      margin: '14px 0'
    },
    optionTitle: {
      margin: '0 0 8px 0',
      fontSize: '1rem',
      fontWeight: '600' as const
    },
    step: {
      margin: '6px 0',
      lineHeight: '1.6',
      fontSize: '0.95rem'
    },
    contact: {
      margin: '16px 0 8px 0',
      fontSize: '0.95rem'
    },
    safe: {
      margin: '16px 0',
      fontWeight: 'bold' as const,
      textAlign: 'center' as const,
      fontSize: '1.05rem'
    },
    backButton: {
      display: 'block',
      width: '220px',
      margin: '32px auto 0',
      padding: '14px 24px',
      backgroundColor: '#1e40af',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '1rem',
      fontWeight: '600' as const,
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    }
  };

  return (
    <div style={styles.container} dir={isRtl ? 'rtl' : 'ltr'}>
      <div style={styles.card}>
        <div style={styles.headerRow}>
          <h1 style={styles.title}>{h.title}</h1>
          <button onClick={() => setShowLangPopup(true)} style={styles.langButton}>
            <img src={flagImg(LANG_MAP.find((l: any) => l.code === lang)?.country || 'GB')} alt="" style={{ width: '24px', height: '18px' }} />
            {lang.toUpperCase()}
          </button>
        </div>

        <p style={styles.welcome}>{h.welcome}</p>
        <p style={styles.intro}>{h.intro}</p>

        <div style={styles.optionBlue}>
          <h3 style={{ ...styles.optionTitle, color: '#1e40af' }}>{h.option1Title}</h3>
          {h.option1Steps.map((step: string, i: number) => (
            <p key={i} style={styles.step}>{step}</p>
          ))}
        </div>

        <div style={styles.optionGreen}>
          <h3 style={{ ...styles.optionTitle, color: '#065f46' }}>{h.option2Title}</h3>
          {h.option2Steps.map((step: string, i: number) => (
            <p key={i} style={styles.step}>{step}</p>
          ))}
        </div>

        <div style={styles.optionYellow}>
          <h3 style={{ ...styles.optionTitle, color: '#78350f' }}>{h.option3Title}</h3>
          {h.option3Steps.map((step: string, i: number) => (
            <p key={i} style={styles.step}>{step}</p>
          ))}
        </div>

        <p style={styles.contact}>{h.contact}</p>
        <p style={styles.safe}>{h.safe}</p>

        <button
          style={styles.backButton}
          onClick={() => navigate(-1)}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#1e3a8a')}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#1e40af')}
        >
          {h.closeBtn}
        </button>
      </div>

      {showLangPopup && (
        <div
          onClick={() => setShowLangPopup(false)}
          style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: 'white', borderRadius: '16px', padding: '24px', maxWidth: '340px', width: '90%', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}
          >
            <h3 style={{ textAlign: 'center', marginBottom: '16px', fontSize: '18px', color: '#1e293b' }}>
              🌍
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
              {LANG_MAP.map(({ code, country, label }: any) => (
                <button
                  key={code}
                  onClick={() => changeLanguage(code)}
                  style={{
                    padding: '12px 8px',
                    borderRadius: '10px',
                    border: 'none',
                    background: lang === code ? 'linear-gradient(135deg, #0c4a6e, #0ea5e9)' : '#f1f5f9',
                    color: lang === code ? 'white' : '#334155',
                    fontSize: '15px',
                    fontWeight: lang === code ? 700 : 500,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}
                >
                  <img src={flagImg(country)} alt="" style={{ width: '24px', height: '18px', borderRadius: '2px' }} />
                  {label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CharterGuidePage;
